
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/conversation-list-unread-badge",
      function () {
        return require("private-next-pages/x/api/chat/conversation-list-unread-badge.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/conversation-list-unread-badge"])
      });
    }
  